import React from 'react';
import { cx } from './cx';

/*
  Логотип WAve — из архива WAve-logo.zip (01.11.2026), исходники в public/brand/{svg,png}.
  Знак — линейный конверт «в движении» (штрих 5.5 на сетке 98×54), надпись — WAve в кривых.
  Все варианты в архиве собраны из этих двух фигур, поэтому здесь они рисуются одним кодом,
  а цвет берётся из токенов: в «auto» надпись тёмная на светлой теме и белая на тёмной.

  variant: horizontal | vertical | mark | wordmark | app
  tone:    auto (по теме) | color (зелёный + графит) | inverse (зелёный + белый) | mono (currentColor) | white
  appTone: green | dark | white — только для variant="app"
*/

const MARK_PATHS = ['M37 11V8.5a6 6 0 0 1 6-6h42.5a6 6 0 0 1 6 6v34.25a6 6 0 0 1-6 6H2.75', 'M21 24h15M11.5 35.75H36', 'M48 17.25l13 8.2a4 4 0 0 0 4.3 0L80.5 17'];
const WORDMARK = 'M332 9Q300 9 280.0 -6.5Q260 -22 248 -54L46 -622Q33 -660 51.5 -687.0Q70 -714 116 -714Q148 -714 165.5 -699.0Q183 -684 194 -652L359 -161H316L490 -651Q502 -683 519.5 -698.5Q537 -714 566 -714Q594 -714 611.0 -698.5Q628 -683 640 -650L806 -161H769L937 -652Q947 -683 965.0 -698.5Q983 -714 1014 -714Q1053 -714 1071.0 -687.0Q1089 -660 1075 -622L871 -53Q860 -22 841.0 -6.5Q822 9 789 9Q757 9 738.0 -6.5Q719 -22 707 -54L549 -501H573L413 -53Q401 -22 382.5 -6.5Q364 9 332 9ZM1128.0 9Q1100.0 9 1082.5 -4.0Q1065.0 -17 1060.5 -39.0Q1056.0 -61 1069.0 -88L1325.0 -649Q1341.0 -683 1363.0 -698.5Q1385.0 -714 1414.0 -714Q1443.0 -714 1465.0 -698.5Q1487.0 -683 1502.0 -649L1760.0 -88Q1773.0 -61 1769.5 -38.5Q1766.0 -16 1749.0 -3.5Q1732.0 9 1705.0 9Q1671.0 9 1652.5 -7.0Q1634.0 -23 1620.0 -57L1560.0 -196L1622.0 -153H1205.0L1267.0 -196L1208.0 -57Q1193.0 -22 1176.5 -6.5Q1160.0 9 1128.0 9ZM1412.0 -540 1284.0 -235 1257.0 -274H1570.0L1543.0 -235L1414.0 -540ZM2007.0 9Q1978.0 9 1956.0 -6.5Q1934.0 -22 1921.0 -53L1770.0 -401Q1759.0 -427 1762.0 -449.5Q1765.0 -472 1783.5 -485.5Q1802.0 -499 1835.0 -499Q1862.0 -499 1879.0 -486.5Q1896.0 -474 1909.0 -439L2027.0 -139H1995.0L2118.0 -440Q2132.0 -474 2149.0 -486.5Q2166.0 -499 2196.0 -499Q2222.0 -499 2237.5 -485.5Q2253.0 -472 2256.5 -450.0Q2260.0 -428 2248.0 -402L2094.0 -53Q2081.0 -21 2059.5 -6.0Q2038.0 9 2007.0 9ZM2556.0 11Q2469.0 11 2406.5 -20.5Q2344.0 -52 2310.5 -109.5Q2277.0 -167 2277.0 -245Q2277.0 -321 2309.0 -378.5Q2341.0 -436 2398.5 -468.5Q2456.0 -501 2529.0 -501Q2582.0 -501 2625.0 -483.5Q2668.0 -466 2699.0 -433.5Q2730.0 -401 2746.0 -354.5Q2762.0 -308 2762.0 -251Q2762.0 -232 2750.0 -222.5Q2738.0 -213 2715.0 -213H2401.0V-291H2653.0L2637.0 -277Q2637.0 -318 2625.0 -345.5Q2613.0 -373 2590.5 -387.0Q2568.0 -401 2535.0 -401Q2498.0 -401 2472.0 -384.0Q2446.0 -367 2432.0 -335.0Q2418.0 -303 2418.0 -258V-250Q2418.0 -174 2453.5 -138.0Q2489.0 -102 2559.0 -102Q2583.0 -102 2614.0 -108.0Q2645.0 -114 2672.0 -127Q2695.0 -138 2713.0 -134.5Q2731.0 -131 2741.0 -118.0Q2751.0 -105 2752.5 -88.0Q2754.0 -71 2745.0 -54.5Q2736.0 -38 2715.0 -27Q2681.0 -8 2638.5 1.5Q2596.0 11 2556.0 11Z';

// Геометрия раскладок взята из файлов архива; охранные поля (20px) срезаны —
// отступ вокруг логотипа задаёт тот, кто его ставит
const LAYOUTS = {
    horizontal: {
        viewBox: '20 20 503.77 108',
        mark: 'translate(20 20) scale(2) translate(1 1)',
        word: 'translate(241.852 109.877) scale(0.102069)',
    },
    vertical: {
        viewBox: '16 20 270.75 224',
        mark: 'translate(42.487 20) scale(2.22222) translate(1 1)',
        word: 'translate(16.077 242.938) scale(0.096552)',
    },
    mark: {
        viewBox: '0 0 98 54',
        mark: 'translate(1 1)',
    },
    // Только надпись — для мест, где знак уже стоит рядом (плитка в меню)
    wordmark: {
        viewBox: '246 36.5 278 75',
        word: 'translate(241.852 109.877) scale(0.102069)',
    },
};

const TONES = {
    auto: { mark: 'var(--ds-logo-mark)', word: 'var(--ds-logo-word)' },
    color: { mark: 'var(--wv-logo-green)', word: 'var(--wv-logo-ink)' },
    inverse: { mark: 'var(--wv-logo-green)', word: '#FFFFFF' },
    mono: { mark: 'currentColor', word: 'currentColor' },
    white: { mark: '#FFFFFF', word: '#FFFFFF' },
};

const APP_TONES = {
    green: { bg: 'var(--wv-logo-green)', mark: '#FFFFFF' },
    dark: { bg: 'var(--wv-logo-ink)', mark: 'var(--wv-logo-green)' },
    white: { bg: '#FFFFFF', mark: 'var(--wv-logo-green)' },
};

function Mark({ transform, color }) {
    return (
        <g transform={transform} fill="none" stroke={color} strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round">
            {MARK_PATHS.map((d) => <path key={d} d={d} />)}
        </g>
    );
}

export function Logo({ variant = 'horizontal', tone = 'auto', appTone = 'dark', height, title = 'WAve', className, style }) {
    const label = { role: 'img', 'aria-label': title };

    if (variant === 'app') {
        const t = APP_TONES[appTone] || APP_TONES.dark;
        const size = height || 40;
        // Как в wave-app-icon-*: знак 61% ширины плитки по центру. Скругление — для интерфейса;
        // в сторы и PWA отдаются квадратные PNG из public/brand, их скругляет платформа
        return (
            <svg viewBox="0 0 1024 1024" width={size} height={size} className={cx('ds-logo', 'ds-logo--app', className)} style={style} {...label}>
                <rect width="1024" height="1024" rx="230" fill={t.bg} />
                <Mark transform="translate(204.8 342.727) scale(6.26939) translate(1 1)" color={t.mark} />
            </svg>
        );
    }

    const layout = LAYOUTS[variant] || LAYOUTS.horizontal;
    const colors = TONES[tone] || TONES.auto;
    const [, , w, h] = layout.viewBox.split(' ').map(Number);
    const px = height || (variant === 'vertical' ? 96 : variant === 'mark' ? 24 : 32);

    return (
        <svg
            viewBox={layout.viewBox}
            height={px}
            width={(px * w) / h}
            className={cx('ds-logo', `ds-logo--${variant}`, className)}
            style={style}
            {...label}
        >
            {layout.mark && <Mark transform={layout.mark} color={colors.mark} />}
            {layout.word && <path transform={layout.word} fill={colors.word} d={WORDMARK} />}
        </svg>
    );
}

// Файлы для скачивания (public/brand) — витрина строит по ним ссылки
export const LOGO_FILES = [
    { name: 'wave-logo-horizontal-color', label: 'Горизонтальный, цветной' },
    { name: 'wave-logo-horizontal-inverse-on-dark', label: 'Горизонтальный на тёмном' },
    { name: 'wave-logo-horizontal-inverse', label: 'Горизонтальный, инверсия (прозрачный фон)' },
    { name: 'wave-logo-horizontal-black', label: 'Горизонтальный, чёрный' },
    { name: 'wave-logo-horizontal-white', label: 'Горизонтальный, белый' },
    { name: 'wave-logo-vertical-color', label: 'Вертикальный, цветной' },
    { name: 'wave-logo-vertical-inverse-on-dark', label: 'Вертикальный на тёмном' },
    { name: 'wave-logo-vertical-inverse', label: 'Вертикальный, инверсия' },
    { name: 'wave-logo-vertical-black', label: 'Вертикальный, чёрный' },
    { name: 'wave-logo-vertical-white', label: 'Вертикальный, белый' },
    { name: 'wave-icon-green', label: 'Знак, зелёный' },
    { name: 'wave-icon-black', label: 'Знак, чёрный' },
    { name: 'wave-icon-white', label: 'Знак, белый' },
    { name: 'wave-app-icon-green', label: 'Иконка приложения, зелёная' },
    { name: 'wave-app-icon-dark', label: 'Иконка приложения, тёмная' },
    { name: 'wave-app-icon-white', label: 'Иконка приложения, белая' },
];
